import React, { useState } from 'react';
import { SignIn, SignUp } from '@clerk/clerk-react';
import { Target, Zap, Shield, TrendingUp } from 'lucide-react';

export default function LoginPage() {
  const [showSignUp, setShowSignUp] = useState(false);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      {/* Left Side - Branding */}
      <div style={{
        flex: 1,
        padding: 60,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        color: 'white'
      }}>
        <div style={{ maxWidth: 500 }}>
          {/* Logo */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 15, marginBottom: 40 }}>
            <Target size={40} style={{ color: '#6366f1' }} />
            <h1 style={{
              fontSize: 36,
              fontWeight: 700,
              margin: 0,
              background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              color: 'transparent'
            }}>
              Bidoryx
            </h1>
          </div>

          {/* Tagline */}
          <h2 style={{
            fontSize: 42,
            fontWeight: 700,
            lineHeight: 1.2,
            marginBottom: 20
          }}>
            AI-Powered Google Ads
            <br />
            <span style={{
              background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              color: 'transparent'
            }}>
              Optimization Platform
            </span>
          </h2>

          <p style={{
            fontSize: 18,
            color: 'rgba(255,255,255,0.6)',
            marginBottom: 40,
            lineHeight: 1.6
          }}>
            Optimize your campaigns, automate keyword research, and create high-converting ads with AI.
          </p>

          {/* Features */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            {[
              { icon: Zap, title: 'AI Optimization', desc: 'Automatically optimize bids, keywords, and ads' },
              { icon: Shield, title: 'Secure & Compliant', desc: 'Bank-level encryption for your Google Ads data' },
              { icon: TrendingUp, title: 'Proven Results', desc: 'Up to 40% improvement in campaign performance' }
            ].map((feature, idx) => (
              <div key={idx} style={{ display: 'flex', gap: 15, alignItems: 'start' }}>
                <div style={{
                  width: 40,
                  height: 40,
                  borderRadius: 10,
                  background: 'rgba(99, 102, 241, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <feature.icon size={20} style={{ color: '#6366f1' }} />
                </div>
                <div>
                  <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600 }}>{feature.title}</h3>
                  <p style={{ margin: '5px 0 0', fontSize: 14, color: 'rgba(255,255,255,0.5)' }}>
                    {feature.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Trial Info */}
          <div style={{
            marginTop: 40,
            padding: 20,
            background: 'rgba(99, 102, 241, 0.1)',
            border: '1px solid rgba(99, 102, 241, 0.3)',
            borderRadius: 12
          }}>
            <p style={{ margin: 0, fontSize: 14, color: 'rgba(255,255,255,0.8)' }}>
              🎉 <strong>7-day free trial</strong> • No credit card required
            </p>
          </div>
        </div>
      </div>

      {/* Right Side - Auth Forms */}
      <div style={{
        width: 500,
        background: 'rgba(255, 255, 255, 0.03)',
        backdropFilter: 'blur(10px)',
        borderLeft: '1px solid rgba(255, 255, 255, 0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 40
      }}>
        <div style={{ width: '100%', maxWidth: 400 }}>
          {showSignUp ? (
            <div>
              <h2 style={{ color: 'white', marginBottom: 30, fontSize: 28, fontWeight: 600 }}>
                Create Account
              </h2>
              <SignUp
                appearance={{
                  elements: {
                    rootBox: 'w-full',
                    card: 'bg-transparent shadow-none'
                  }
                }}
                routing="hash"
              />
              <p style={{ textAlign: 'center', marginTop: 20, color: 'rgba(255,255,255,0.6)' }}>
                Already have an account?{' '}
                <button
                  onClick={() => setShowSignUp(false)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#6366f1',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    fontSize: 14
                  }}
                >
                  Sign In
                </button>
              </p>
            </div>
          ) : (
            <div>
              <h2 style={{ color: 'white', marginBottom: 30, fontSize: 28, fontWeight: 600 }}>
                Welcome Back
              </h2>
              <SignIn
                appearance={{
                  elements: {
                    rootBox: 'w-full',
                    card: 'bg-transparent shadow-none'
                  }
                }}
                routing="hash"
              />
              <p style={{ textAlign: 'center', marginTop: 20, color: 'rgba(255,255,255,0.6)' }}>
                Don't have an account?{' '}
                <button
                  onClick={() => setShowSignUp(true)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#6366f1',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    fontSize: 14
                  }}
                >
                  Sign Up
                </button>
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

